// extracted by mini-css-extract-plugin
export default {"pageActions":"Blackout_pageActions__B5qzl","columns":"Blackout_columns__QjNTb"};